var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 216,
    viewBox: "0 0 196 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON MASSAGE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.8444 31.3485C49.1317 40.4053 41.1827 44.4023 36.6615 44.1169C32.7467 43.8697 24.9022 39.6625 24.6113 27.9229",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.9233 28.1834C23.9233 28.1834 36.6018 17.6086 52.4632 17.3702C55.6796 5.6606 41.6947 3.65711 35.077 6.26549C28.4594 8.87388 19.5118 17.014 23.9233 28.1834Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.6327 19.4414C40.6327 19.4414 48.7212 20.7664 50.1112 32.179C50.1112 32.179 55.8717 26.4715 52.4704 17.3703",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.3406 5.03262C41.3406 5.03262 33.497 0.00572162 26.6634 3.63645C19.8297 7.26718 23.2191 17.4718 23.2191 17.4718",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.2434 40.5843C29.2434 40.5843 30.0808 48.4361 26.4927 49.3195C22.9047 50.2029 7.17891 48.8269 5.74168 58.5537C5.36747 61.0877 4.97826 65.0088 4.97826 65.0088",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.3838 40.7588C45.3838 40.7588 44.3769 48.5907 47.945 49.5515C51.5131 50.5123 67.9198 49.4206 68.4915 59.2322C68.6906 62.6946 69.1152 65.7023 69.1152 65.7023",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M60.1951 42.1879C60.1951 42.1879 59.2045 39.0322 61.1712 35.0178C63.1379 30.9956 61.6024 25.0201 61.6024 25.0201",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M70.0228 45.179C70.0228 45.179 68.2321 39.4845 71.7865 32.232C75.341 24.9794 72.5571 14.1823 72.5571 14.1823",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.4457 41.7041C15.4457 41.7041 16.5042 38.5705 14.6248 34.5146C12.7455 30.4507 14.4098 24.5098 14.4098 24.5098",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M5.55447 44.4821C5.55447 44.4821 7.4679 38.8276 4.07109 31.4999C0.674289 24.1722 3.69097 13.4378 3.69097 13.4378",
    stroke: "#EF7056",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "ICON COFFEE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M115.307 72.2495C113.692 65.9048 114.22 55.367 114.992 48.2498C114.992 48.2498 155.315 48.0843 166.239 48.2498C166.404 64.0447 165.064 85.7193 154.479 87.9026C145.928 89.6681 132.119 88.8011 127.122 88.3991C125.688 88.2809 123.63 86.9016 122.464 86.0898",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M166.735 51.2686C166.735 51.2686 180.512 47.4065 178.833 60.5059C177.155 73.6052 165.056 72.2654 165.056 72.2654",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M140.339 39.0047C140.339 39.0047 138.92 35.3949 141.868 30.0353C144.824 24.6758 142.743 18 142.743 18",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M151.169 41.448C151.169 41.448 149.159 36.3091 152.446 32.455C155.732 28.6087 153.707 25.9684 153.707 25.9684",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M131.212 24.9595C131.212 24.9595 133.222 30.0983 129.935 33.9525C126.649 37.7987 128.674 40.4391 128.674 40.4391",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M118.113 70.6339C123.425 70.7758 125.529 75.757 124.71 81.5737C123.882 87.3982 118.026 87.5322 118.026 87.5322C118.026 87.5322 111.429 87.9578 111.429 78.6969C111.429 70.6339 118.113 70.6339 118.113 70.6339Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M118.113 70.6339C118.113 70.6339 120.572 73.6447 120.407 75.757C120.044 80.3126 114.543 81.7156 118.026 87.5401",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M111.729 83.8987C111.729 83.8987 105.581 86.208 109.073 90.2434C111.887 93.4907 123.504 94.1606 138.479 94.2788C153.455 94.3971 164.048 93.404 166.286 90.1331C169.872 84.8839 160.288 83.7883 160.288 83.7883",
    stroke: "#EF7056",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "ICON PET FRIENDLY"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M64.0342 100.871C68.3522 100.583 68.123 114.69 64.3521 114.809C59.2281 114.971 56.9064 101.352 64.0342 100.871Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M74.2828 108.642C78.0241 108.391 77.8245 120.628 74.5638 120.731C70.12 120.872 68.1014 109.056 74.2828 108.642Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M40.0045 109.685C43.7458 109.433 43.5462 121.67 40.2854 121.774C35.8417 121.914 33.8231 110.099 40.0045 109.685Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M49.0467 100.79C44.7286 100.501 44.9578 114.609 48.7287 114.727C53.8528 114.89 56.1745 101.27 49.0467 100.79Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M62.334 118.809C67.0809 119.888 71.2881 122.728 73.8464 126.876C74.852 128.51 75.51 130.166 75.5692 131.541C75.7318 135.223 70.2825 141.153 64.8405 137.952C59.3912 134.75 56.5075 135.63 53.6313 138.27C50.755 140.909 39.213 140.355 40.8175 131.541C42.422 122.728 50.7476 118.328 55.7977 118.084C57.9641 117.981 60.3376 118.35 62.3414 118.809H62.334Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M37.3425 94.5715C37.3425 94.5715 44.0488 88.8337 57.247 88.7598C67.6282 88.7006 91.0005 92.6564 91.0005 121.212C91.0005 121.803 90.9857 122.402 90.9561 122.994C89.9506 143.823 79.4363 152.023 57.04 152.133C41.387 152.207 26.4216 147.808 23.7819 124.502C23.6119 122.972 23.501 121.449 23.501 119.918C23.501 114.787 24.2552 110.498 25.5491 106.912",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M29.1427 88.2864C24.2257 87.7097 18.8429 90.5342 18.0813 96.856C18.0296 97.2997 18 97.7433 18 98.1869C18 106.453 24.7655 107.208 27.7748 107.208C30.7842 107.208 37.5497 106.076 37.5497 97.8098C37.5497 97.6398 37.5497 97.4623 37.5349 97.2923C37.4683 95.9022 36.3001 93.27 35.8269 92.1978",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M23.8049 96.2572C23.8049 96.2572 27.0435 99.6363 28.1452 100.745C30.7405 92.8412 34.4153 87 34.4153 87",
    stroke: "#EF7056",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "ICON BREAKFAST"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M145.493 176.107L137.838 177.722L133.268 157.176C133.268 157.176 126.112 158.091 125.204 153.369C124.295 148.647 126.424 146.671 131.597 145.908C136.77 145.145 158.384 141.04 158.384 141.04C158.384 141.04 163.404 140.277 164.015 145C164.625 149.722 160.818 151.393 160.818 151.393L162.288 158.223",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M158.863 162.314C158.863 162.314 160.049 158.161 165.984 158.244C171.92 158.327 171.414 162.481 171.414 162.481L171.157 175.961L163.017 176.384L158.863 162.307V162.314Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M171.414 162.481C171.414 162.481 174.638 159.679 179.215 161.801C183.791 163.923 183.708 168.077 183.708 168.077L176.753 177.743L171.157 175.961",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M183.708 168.083C183.708 168.083 188.874 169.248 188.368 177.729C186.246 178.998 183.882 180.676 182.772 181.48L176.753 177.75",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M158.862 162.314C158.862 162.314 156.151 161.551 153.432 163.077C149.036 165.552 150.153 168.59 150.153 168.59L157.108 178.256L162.704 176.474",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M150.16 168.59C150.16 168.59 145.244 169.852 145.75 178.332C148.607 180.704 151.09 181.987 151.09 181.987L157.108 178.256",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M146.36 143.328C146.36 143.328 146.055 136.172 149.709 131.915C157.988 122.248 164.458 126.95 170.103 124.758C178.32 121.562 193.769 121.104 193.998 137.698C194.151 148.508 182.432 146.983 182.279 154.139C182.127 161.295 180.15 162.203 180.15 162.203",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M181.509 139.944C181.114 148.058 169.146 148.307 168.182 140.243C168.147 139.938 168.126 139.639 168.126 139.334C168.126 133.669 172.765 133.149 174.825 133.149C176.884 133.149 181.523 133.919 181.523 139.591C181.523 139.709 181.523 139.827 181.516 139.944H181.509Z",
    stroke: "#EF7056",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "ICON POINTS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ROUND",
    d: "M75.3366 204.119C83.1018 205.291 82.239 213.496 76.6308 213.105C71.0226 212.714 68.003 205.291 75.3366 204.119Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "ROUND_2",
    d: "M94.1764 205.252C97.8968 211.858 90.5813 216.684 87.5169 212.217C84.4525 207.75 88.7755 200.534 94.1764 205.252Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "ROUND_3",
    d: "M105.33 203.982C112.835 205.059 112.202 213.8 106.793 213.507C101.384 213.214 98.2981 205.388 105.33 203.982Z",
    stroke: "#EF7056",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.9de61365200dae0c05f6549b27020012.svg";
export { ForwardRef as ReactComponent };